module.exports = __webpack_public_path__ + "img/ic-flag-green.6297989d.svg";